<template>
  <div class="dt-details">
      <div class="dt-details--header">
        {{$t('user_details_for')}} {{userDetails.usr.user_name}}
      </div>
      <!-- <div class="dt-details--body">
        <div class="dt-details--col">
          <div class="dt-details--row">
            <div class="dt-details--label"> {{$t('username')}} </div>
            <div class="dt-details--value" v-if="userDetails">{{userDetails.usr.user_name}} </div>
          </div>
          <div class="dt-details--row">
            <div class="dt-details--label"> {{$t('fullname')}} </div>
            <div class="dt-details--value" v-if="userDetails"> {{userDetails.usr.staff_fullname}} </div>
          </div>
        </div>
        <div class="dt-details--col">
          <div class="dt-details--row">
            <div class="dt-details--label"> {{$t('phone1')}} </div>
            <div class="dt-details--value" v-if="userDetails"> {{userDetails.usr.staff_phone1}} </div>
          </div>
          <div class="dt-details--row">
            <div class="dt-details--label"> {{$t('phone2')}} </div>
            <div class="dt-details--value" v-if="userDetails"> {{userDetails.usr.staff_phone2}} </div>
          </div>
        </div>
        <div class="dt-details--col">
          <div class="dt-details--row">
            <div class="dt-details--label"> {{$t('email')}} </div>
            <div class="dt-details--value" v-if="userDetails"> {{userDetails.usr.staff_email}} </div>
          </div>
          <div class="dt-details--row">
            <div class="dt-details--label"> {{$t('User Id')}} </div>
            <div class="dt-details--value" v-if="userDetails"> {{userDetails.usr.user_id}} </div>
          </div>
        </div>
        <div class="dt-details--col">
          <div class="dt-details--row">
            <div class="dt-details--label"> {{$t('jobtitle')}} </div>
            <div class="dt-details--value" v-if="userDetails"> {{userDetails.usr.job_title}} </div>
          </div>
        </div>
      </div> -->
    </div>
</template>

<script>

export default {
  props: {
    userDetails: {
      type: Object
    }
  }
}
</script>

<style>

</style>
